const musicRouteUrls = [
  "/es/musica/",
  "/es/musica/noticias/",
  "/es/musica/terror/",
  "/es/musica-sin-copyright/",
  "/es/musica/deportes/",
  "/es/musica/motivadora/",
  "/es/musica/epica/",
  "/es/musica/inspiradora/",
  "/non-copyright-music/roblox-edits/",
  "/es/musica/para-ninos/",
  "/es/musica/ambiental/",
  "/es/musica/clasica/",
  "/es/musica/anime/",
  "/fr/musique/espace/",
  "/background-music/camping-videos/",
  "/fr/musique/pour-enfants/",
  "/es/musica/espacio/",
  "/fr/musique/ukulele/",
  "/es/musica/triste/",
  "/non-copyright-music/respect-video/",
  "/es/musica/alegre/",
  "/fr/musique/horreur/",
  "/es/musica/8-bit/",
  "/fr/musique/triste/",
  "/fr/musique/anime/",
  "/fr/musique/",
  "/fr/musique/jazz/",
  "/fr/musique/epique/",
  "/es/musica/jazz/",
  "/es/musica/corporativa/",
  "/music-for/veterinary-clinics/",
  "/fr/musique/sport/",
  "/music/",
  "/es/musica/animada/",
  "/music-for/athletic-events/",
  "/background-music/family-video/",
  "/fr/musique/informations/",
  "/es/musica/rock-indie/",
  "/fr/musique/inspirante/",
  "/es/musica/relajante/",
  "/es/musica-sin-copyright/accion/",
  "/fr/musique/pop/",
  "/music-for/hospitals/",
  "/es/musica-sin-copyright/naturaleza/",
  "/fr/musique/8-bits/",
  "/fr/musique/funk/",
  "/es/musica-sin-copyright/outro/",
  "/non-copyright-music/montage/",
  "/fr/musique/relaxant/",
  "/non-copyright-music/poetry/",
  "/es/musica/trap/",
  "/fr/musique/motivation/",
  "/music-for/contemporary-dance-classes/",
  "/music-for/apartments/",
  "/fr/musique/classique/",
  "/es/musica/ukelele/",
  "/es/musica/funk/",
  "/fr/musique/piano/",
  "/fr/musique/ambiance/",
  "/es/musica/pop/",
  "/fr/musique/enjoue/",
  "/music-for/aquagym-classes/",
  "/music/jazz/",
  "/es/musica/piano/",
  "/music-for/zumba-classes/",
  "/es/musica/acustica/",
  "/es/musica/lo-fi/",
  "/es/musica/metal/",
  "/music/classical/",
  "/music/8-bit/",
  "/es/musica/electronica/",
  "/es/categoria/sobre-derechos-autor/",
  "/es/musica/synthwave/",
  "/non-copyright-music/cricket-videos/#basic-concepts",
  "/background-music/facts-video/#key-takeaways",
  "/music/news-newcast/",
  "/music-for/pilates-classes/",
  "/music-for/casinos/",
  "/music/synthwave/",
  "/es/musica-sin-copyright/cinematica/",
  "/music/all/",
  "/non-copyright-music/cricket-videos/#key-takeaways",
  "/non-copyright-music/cricket-videos/#copyright-free-music-sources",
  "/music/horror/",
  "/music/ambient/",
  "/music/ukulele/",
  "/music/rock-indie/",
  "/fr/musique/rock/",
  "/non-copyright-music/cinematic-video/",
  "/fr/musique/chill/",
  "/non-copyright-music/food-blog/",
  "/non-copyright-music/reels/#how-to-choose-the-right-music-for-your-reels",
  "/non-copyright-music/reels/#what-is-royalty-free-music",

  //  from rows 800-1000
  "/accidentally-use-copyrighted-music",
  "/artlist-epidemic-sound-comparative-guide",
  "/background-music-banks-financial-institutions",
  "/background-music-for-twitch",
  "/background-music-for-youtube-ads",
  "/background-music-tv-quiz-shows",
  "/background-music/camping-videos",
  "/background-music/construction-video",
  "/background-music/graduation-video",
  "/buy-music-for-youtube-videos",
  "/category/music-social-media",
  "/category/tv-cinema-others",
  "/choose-best-music-for-video",
  "/distribution-music-royalties-spain",
  "/duration-of-copyright",
  "/es/artlist-epidemic-sound-guia-comparativa",
  "/es/cloud-cover-music-opinion-y-guia",
  "/es/como-registrar-sus-canciones",
  "/es/comprar-canciones-para-uso-comercial",
  "/es/copyright-covers-youtube",
  "/es/donde-conseguir-musica-ascensor",
  "/es/elegir-musica-adecuada-video",
  "/es/eliminar-strikes-youtube",
  "/es/encontrar-musica-libre-derechos-similar",
  "/es/legal-spotify-negocio",
  "/es/licencias-creative-commons",
  "/es/musica-ambiental-negocios-tiendas-comercios",
  "/es/musica-cuentos-infantiles",
  "/es/musica-discotecas-bares-de-copas",
  "/es/musica-efectos-sonido-apps",
  "/es/musica-fondo-bancos-instituciones-financieras",
  "/es/musica-fondo-dominio-publico",
  "/es/musica-fondo-farmacias",
  "/es/musica-fondo-linkedin",
  "/es/musica-fondo-supermercados",
  "/es/musica-para-anuncios",
  "/es/musica-sin-copyright-gameplays",
  "/es/musica-twitch",
  "/es/problemas-derechos-autor-redes-sociales",
  "/es/reclamaciones-derechos-de-autor-youtube",
  "/es/reparto-derechos-autor-espana",
  "/fr/acheter-chansons-fins-commerciales",
  "/fr/artlist-vs-epidemic-sound",
  "/fr/comment-obtenir-licence-chansons-connues",
  "/fr/decouvrir-nom-chanson",
  "/fr/droits-auteur-musique-musique-classique",
  "/fr/droits-dauteur-couverture-youtube",
  "/fr/droits-dauteur-youtube",
  "/fr/musique-ambiance-hotels-luxe",
  "/fr/musique-contes-pour-enfants",
  "/fr/musique-dambiance-cuisine-videos",
  "/fr/musique-facebook",
  "/fr/musique-fond-decran-publicites-youtube",
  "/fr/musique-fond-pour-pesentations-videos",
  "/fr/musique-noel-libre-droits",
  "/fr/musique-pour-les-videos-immobilieres",
  "/fr/musique-pour-linkedin",
  "/fr/musique-pour-podcast",
  "/fr/musique-pour-publicite",
  "/fr/musique-pour-publicites-en-ligne",
  "/fr/musique-supermarches-magasins-alimentaires",
  "/fr/musique/acoustique",
  "/fr/musique/entreprise",
  "/fr/quest-ce-que-musique-stock",
  "/fr/types-licences-musicales",
  "/how-to-see-if-song-is-copyrighted",
  "/incidental-music",
  "/music-nightclubs-cocktail-bars",
  "/music-youtubers-use",
  "/music/anime",
  "/music/chill",
  "/music/corporate",
  "/music/funky",
  "/music/inspiring",
  "/music/piano",
  "/music/space",
  "/music/trap",
  "/music/uplifting",
  "/non-copyright-music/facebook-reels",
  "/non-copyright-music/gaming-video-montages-intro",
  "/register-songs-intellectual-property",
  "/types-music-licenses-guide",
  "/what-is-stock-music",
  //new append
  "/es/categoria/sobre-derechos-autor",
  "/es/musica-sin-copyright/accion",
  "/es/musica/acustica",
  "/es/musica/animada",
  "/es/musica/electronica",
  "/es/musica/funk",
  "/es/musica/lo-fi",
  "/es/musica/metal",
  "/es/musica/piano",
  "/es/musica/pop",
  "/es/musica/relajante",
  "/es/musica/rock-indie",
  "/es/musica/synthwave",
  "/es/musica/trap",
  "/es/musica/ukelele",
  "/fr/musique/8-bits",
  "/fr/musique/ambiance",
  "/fr/musique/chill",
  "/fr/musique/classique",
  "/fr/musique/enjoue",
  "/fr/musique/funk",
  "/fr/musique/informations",
  "/fr/musique/inspirante",
  "/fr/musique/motivation",
  "/fr/musique/piano",
  "/fr/musique/relaxant",
  "/fr/musique/rock",
  "/fr/musique/sport",
  "/music",
  "/music/8-bit",
  "/music/ambient",
  "/music/children-kids",
  "/music/cinematic-epic",
  "/music/classical",
  "/music/corporate",
  "/music/folk-acoustic",
  "/music/happy",
  "/music/jazz",
  "/music/news-newcast",
  "/music/pop",
  "/music/relaxing",
  "/music/rock-indie",
  "/music/sad",
  "/music/synthwave",
  "/music/ukulele",
  "/music/upbeat",
  "/background-music/construction-video/#types-of-music-suitable-for-construction-videos"
];

export default musicRouteUrls;
